import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import classes from '../index.module.scss';
import { feedbackReportsSearchPost } from 'api';

const SupportContainer = () => {

  const [count, setCount] = useState(0);

  const REPORT_SEARCH_SELECT = [
    "replied_by",
    "reply_time",
  ]

  const fullTextParams = {
    select: REPORT_SEARCH_SELECT
  };

  const data = {
    replied_by: null
  }

  const requestHandler = (fullTextParams) => {
    feedbackReportsSearchPost(fullTextParams, data)
      .then(response => {
        setCount(response.data.results.length);
      })
      .catch(error => {
        console.log(error)
      })
  }

  useEffect(() => {
    requestHandler(fullTextParams);
  }, [count])
  
  return (
    <div className={classes.Support_Wrapper}>
      <div>
        You have <span>{count}</span> support requests
      </div>
      <Link
        to="/user-feedback"
        className="btnSizes transparentBtn"
      >
        Support/Feedback
      </Link>
    </div>
  )
}

export default SupportContainer;

